module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABvSURBVHgB7dixDYAwDETRExMwAiMwApvA5oxiUlCkRUSyL/pPcv9P6SIBAIDvImKVqxa/tbvbHXLTxV9yQ3wW4rMQn4X4LMRnIf6HReOEXHWvcMoVI6pgRBWMqIIRVTCiitlG7HL1jvD94AUAYIQHxpAg/gYy580AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/left.png
// module id = /IG+
// module chunks = 0